// Local translations
export const T = {
  en_GB: {
    // Page
    settings: "Settings",
    description: "Manage your application settings",
    // Cards
    clients: "Clients",
    clientsDescription: "Configure standard and custom client fields, and manage client views.",
    dashboards: "Dashboards",
    dashboardsDescription:
      "Choose which widgets users see on the User Dashboard and the Performance Dashboard.",
    flows: "Flows",
    flowsDescription: "Build multi-page forms and workflows for clients to fill out.",
    riskModels: "Risk Models",
    riskModelsDescription: "Create risk assessment models with time horizons and scoring matrices.",
    financialSituationModels: "Financial Situation Models",
    financialSituationModelsDescription:
      "Define income, asset, liability, and commitment fields for MiFID II assessments.",
    portfolioCollections: "Portfolio Collections",
    portfolioCollectionsDescription:
      "Create collections with product registers and risk-based allocations.",
    pdfTemplates: "PDF Templates",
    pdfTemplatesDescription: "Design templates that auto-generate when flows are completed.",
    theme: "Theme",
    themeDescription: "Upload your logo and set your primary brand color.",
    regional: "Regional settings",
    regionalDescription: "Configure date and number formats and languages.",
    apiKeys: "API Keys",
    apiKeysDescription: "Create keys to access Quantfolio Platform from external applications.",
    webhooks: "Webhooks",
    webhooksDescription:
      "Receive real-time notifications when events occur in Quantfolio Platform.",
    organization: "Organization",
    organizationDescription: "Change your organization's name and web address.",
    users: "Users",
    usersDescription: "Add and manage user accounts for your organization.",
    teams: "Teams",
    teamsDescription:
      "Group users into teams to filter clients and, if you choose, limit who sees them.",
    aiModels: "AI Settings",
    aiModelsDescription: "Configure AI models, providers, and sidebar agents.",
    usage: "Usage",
    usageDescription: "Monthly metered cost for 3rd-party features and AI, by user and type.",
    sso: "Single Sign-On (SSO)",
    ssoDescription: "Allow users to sign in with your organization's identity provider.",
    compliance: "3rd party features",
    complianceDescription: "Configure PEP/sanction screening and ID verification providers.",
    billing: "Billing & Plans",
    billingDescription: "Manage your subscription, view usage, and upgrade your plan.",
    customInstruments: "Custom Instruments",
    customInstrumentsDescription: "Manage your custom instruments",
    combinedInstruments: "Combined Instruments",
    combinedInstrumentsDescription: "Manage combined instruments and their configurations.",
  },
  nb_NO: {
    // Page
    settings: "Innstillinger",
    description: "Administrer applikasjonsinnstillingene dine",
    // Cards
    clients: "Kunder",
    clientsDescription:
      "Konfigurer standard- og egendefinerte kundefelt, og administrer kundevisninger.",
    dashboards: "Dashbord",
    dashboardsDescription:
      "Velg hvilke widgeter brukerne ser på Brukerdashbordet og Resultatdashbordet.",
    flows: "Flyter",
    flowsDescription: "Bygg flersidet skjemaer og arbeidsflyter for kunder å fylle ut.",
    riskModels: "Risikomodeller",
    riskModelsDescription:
      "Opprett risikovurderingsmodeller med tidshorisonter og scoringsmatriser.",
    financialSituationModels: "Finansiell situasjonsmodeller",
    financialSituationModelsDescription:
      "Definer inntekt-, eiendel-, gjeld- og forpliktelsesfelt for MiFID II-vurderinger.",
    portfolioCollections: "Porteføljesamlinger",
    portfolioCollectionsDescription:
      "Opprett samlinger med produktregistre og risikobaserte allokeringer.",
    pdfTemplates: "PDF-maler",
    pdfTemplatesDescription: "Design maler som genereres automatisk når flyter fullføres.",
    theme: "Tema",
    themeDescription: "Last opp logoen din og angi din primære merkefarge.",
    regional: "Regionale innstillinger",
    regionalDescription: "Konfigurer dato- og tallformater og språk.",
    apiKeys: "API-nøkler",
    apiKeysDescription:
      "Opprett nøkler for å få tilgang til Quantfolio Platform fra eksterne applikasjoner.",
    webhooks: "Webhooks",
    webhooksDescription: "Motta sanntidsvarsler når hendelser oppstår i Quantfolio Platform.",
    organization: "Organisasjon",
    organizationDescription: "Endre organisasjonens navn og nettadresse.",
    users: "Brukere",
    usersDescription: "Legg til og administrer brukerkontoer for organisasjonen din.",
    teams: "Team",
    teamsDescription:
      "Samle brukere i team for å filtrere kunder og eventuelt begrense hvem som ser dem.",
    aiModels: "AI-innstillinger",
    aiModelsDescription: "Konfigurer AI-modeller, leverandører og sidebar-agenter.",
    usage: "Forbruk",
    usageDescription: "Månedlig målt kostnad for tredjepartsfunksjoner og AI, per bruker og type.",
    sso: "Enkel pålogging (SSO)",
    ssoDescription: "La brukere logge på med organisasjonens identitetsleverandør.",
    compliance: "Tredjepartsfunksjoner",
    complianceDescription: "Konfigurer PEP-/sanksjonskontroll og ID-verifisering.",
    billing: "Fakturering og planer",
    billingDescription: "Administrer abonnement, se bruk og oppgrader planen din.",
    customInstruments: "Egendefinerte instrumenter",
    customInstrumentsDescription: "Administrer dine egendefinerte instrumenter.",
    combinedInstruments: "Kombinerte instrumenter",
    combinedInstrumentsDescription: "Administrer kombinerte instrumenter og deres konfigurasjoner.",
  },
} as const;
